var _style, _defs, _clipPath, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseAppContainerAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "use-app-container-android_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 490 650",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "use-app-container-android_svg__SVGID_1_",
    d: "M0 0h490v650H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "use-app-container-android_svg__SVGID_00000063592200666072755130000016396749215578359196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#use-app-container-android_svg__SVGID_1_",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453 0H37C16.5 0 0 16.5 0 37v616.7c0 12.2 5.9 23.1 15.1 29.8-.1-.7-.1-1.4-.1-2.1v-612C15 53.2 28.2 40 44.4 40h401.1c16.3 0 29.4 13.2 29.4 29.4v611.9c0 .7 0 1.4-.1 2.1 9.1-6.7 15.1-17.6 15.1-29.8V37C490 16.5 473.5 0 453 0zM245 24.8c-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1z",
    clipPath: "url(#use-app-container-android_svg__SVGID_00000063592200666072755130000016396749215578359196_)",
    fill: "#dadada"
  })));
}
export default SvgUseAppContainerAndroid;